import {
  isOllas,
  isB2BPrinter,
  isB2BUploader,
  isSATUploader,
  isSATPrinter,
  isB2BRetry,
  isScanPack,
  isAdmin,
  isStaff,
  isDSVPrinter,
  isDSVStock,
  isDSVRetry,
  isSFPStock,
  isLolina,
  isSorterRetry,
  isSATRetry,
  isBulkdrop,
} from 'modules/user-has-permission/user-has-permission';

export default function getRedirectPath() {
  if (isOllas()) return '/ollas-upload';
  if (isSATUploader()) return '/sat-upload';
  if (isSATRetry()) return '/retry-shipments';
  if (isSATPrinter()) return '/sat-printer';
  if (isB2BUploader()) return '/b2b-upload';
  if (isB2BPrinter() || isDSVPrinter() || isDSVStock() || isSFPStock())
    return '/preparation-orders';
  if (isB2BRetry()) return '/retry-shipments';
  if (isScanPack()) return '/retry-scanpack-shipments';
  if (isLolina()) return '/retry-lolina-shipments';
  if (isSorterRetry()) return '/retry-sorter-shipments';
  if (isAdmin()) return '/configuration';
  if (isStaff()) return '/warehouse-management';
  if (isDSVRetry()) return '/dsv/pending-orders';
  if (isBulkdrop()) return '/retry-bulkdrop-shipments';

  return '/login';
}
